import api from '@/sui/api/api'
import delay from '@/sui/api/delay'
import password from '@/sui/tools/password'

let module = null

const remote = true
if (remote) {
  module = {
    login (email, pwd) {
      const request = {
        em: email,
        p: password(email, pwd)
      }
      return api.post('/login', request)
    }
  }
} else {
  module = {
    _try: 0,

    login (email, password) {
      this._try++
      const result = (this._try > 1) ? {
        t: 'token',
        n: 'Eiruc',
        f: 'Marie',
        em: 'maire.eiruc@chu-test.fr',
        es: []
      } : { err: 'error' }
      return delay(100)({ data: result })
    }
  }
}
export default module
